import { useEffect, useState } from "react";
import { createFieldApi } from "../utils/createFieldApi.js";
import { useFormInternalContext } from "../utils/formContext.js";
function useFormFieldApi(fieldName) {
  const { api } = useFormInternalContext();
  const [fieldApi, setFieldApi] = useState(() => {
    return createFieldApi(api, fieldName);
  });
  useEffect(() => {
    setFieldApi(createFieldApi(api, fieldName));
  }, [api, fieldName]);
  return fieldApi;
}
export {
  useFormFieldApi
};
//# sourceMappingURL=useFormFieldApi.js.map
